import { call, select, put, takeLatest } from 'redux-saga/effects';
import api from 'utils/api';

import {
  PAYERS_REQUESTED,
  PAYER_PLANS_REQUESTED,
  payersReceived,
  payerPlansReceived,
  payerPlansFetching,
} from 'shared/actions/PayersActions';

function* maybeFetchPayers() {
  const payers = yield select(state => state.payers.items);
  if (payers.length > 0) return;

  const response = yield call(api.get, '/shared/api/referral_profiles/payers.json');
  yield put(payersReceived(response.data));
}

function* fetchPayerPlans({ payerId }) {
  yield put(payerPlansFetching(payerId));

  const path = '/shared/api/referral_profiles/plans.json';
  const params = {
    payer_id: payerId,
  };
  const response = yield call(api.get, path, { params });

  yield put(payerPlansReceived(payerId, response.data));
}

export default function* payersSaga() {
  yield takeLatest(PAYERS_REQUESTED, maybeFetchPayers);
  yield takeLatest(PAYER_PLANS_REQUESTED, fetchPayerPlans);
}
